<template>
  <t-modal transition="slide-right" :visible="visible" fullscreen @update:visible="handleBack">
    <payment-form
      :disabled="isCancelling"
      :loading="isSubmitting"
      :message="message"
      :amount="message.message_rich.options.payment_amount"
      @back="handleBack"
      @submit="handleSubmit"
    ></payment-form>
  </t-modal>
</template>

<script>
import PaymentForm from './PaymentForm'
import { Chat } from 'src/apis'
import { mapState } from 'pinia'
import { useSettingsStore } from 'Store/settings'

export default {
  name: 'CustomBotPaymentModal',

  components: { PaymentForm },

  props: {
    message: { type: Object, required: true },
    visible: Boolean
  },

  data() {
    return {
      isSubmitting: false,
      isCancelling: false
    }
  },

  computed: {
    ...mapState(useSettingsStore, {
      paymentGatewaySetting: 'paymentGatewaySetting'
    })
  },

  created() {
    if (this.message.is_from_pubnub) {
      // if the message is from PubNub then open it immediately
      this.$emit('update:visible', true)
    }
  },

  methods: {
    handleBack() {
      if (this.isCancelling || this.isSubmitting) return

      this.isCancelling = true
      Chat.sendMessage(this.$t('base.pay'), {
        card_token: null,
        payment_gateway: this.paymentGatewaySetting.name
      })
        .then(() => {
          this.$emit('update:visible', false)
        })
        .finally(() => {
          this.isCancelling = false
        })
    },

    handleSubmit({ card_token, paypal_order_id, payment_gateway } = {}) {
      if (this.isCancelling || this.isSubmitting) return

      this.isSubmitting = true
      Chat.sendMessage(this.$t('base.pay'), {
        card_token,
        paypal_order_id,
        payment_gateway,
        amount: this.message.message_rich.options.payment_amount
      })
        .then(() => {
          this.$emit('update:visible', false)
          this.$emit('payment-success')
        })
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>
